export const edySupportCasesTranslations = {
  lv: {
    title: 'Atbalsta gadījumi',
    search: 'Meklēt pēc lietotāja vārda, uzvārda vai e-pasta',
    empty: 'Atbalsta gadījumi nav atrasti',
    columns: {
      started: 'Sākts',
      caseNr: 'Gadījuma nr.',
      supportUser: 'Atbalsta lietotājs',
      user: 'Lietotājs',
      email: 'E-pasts',
      actions: 'Darbības',
    },
    actions: {
      showLog: 'Rādīt žurnālu',
    },
    log: {
      title: 'Žurnāls: {{caseNr}} · {{user}}',
      empty: 'Šim atbalsta ierakstam žurnāla ierakstu nav',
      loadFailed: 'Neizdevās ielādēt žurnālu',
      columns: {
        date: 'Datums',
        logKind: 'Žurnāls',
        type: 'Darbība',
        info: 'Informācija',
      },
      kinds: {
        User: 'Lietotājs',
        Org: 'Organizācija',
        Edu: 'Izglītības iestāde',
        Intern: 'Praktikants',
        Edy365: 'Edy365',
      },
    },
    filters: {
      button: 'Filtri',
      title: 'Filtrēt atbalsta gadījumus',
      clear: 'Notīrīt',
      apply: 'Filtrēt',
      active: 'Aktīvie filtri',
      remove: 'Noņemt filtru “{{filter}}”',
      all: 'Visi',
      supportUserId: 'Atbalsta lietotājs',
    },
  },
  en: {
    title: 'Support cases',
    search: 'Search by user first name, last name or email',
    empty: 'No support cases found',
    columns: {
      started: 'Started',
      caseNr: 'Case no.',
      supportUser: 'Support user',
      user: 'User',
      email: 'Email',
      actions: 'Actions',
    },
    actions: {
      showLog: 'Show log',
    },
    log: {
      title: 'Log: {{caseNr}} · {{user}}',
      empty: 'This support entry has no log entries',
      loadFailed: 'Could not load the log',
      columns: {
        date: 'Date',
        logKind: 'Log',
        type: 'Action',
        info: 'Info',
      },
      kinds: {
        User: 'User',
        Org: 'Organization',
        Edu: 'Education institution',
        Intern: 'Intern',
        Edy365: 'Edy365',
      },
    },
    filters: {
      button: 'Filters',
      title: 'Filter support cases',
      clear: 'Clear',
      apply: 'Apply filters',
      active: 'Active filters',
      remove: 'Remove “{{filter}}” filter',
      all: 'All',
      supportUserId: 'Support user',
    },
  },
}
